import Swiper, { Navigation, Pagination, Autoplay, FreeMode, Mousewheel, Grid} from 'swiper';

function checkAutoplay(slider, wrapper) {
    if(slider.autoplay.running != false){
        wrapper.classList.add('slider--autoplay');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('.jsSliderArtistGallery')){
        const jsSliderArtistGallery = new Swiper('.jsSliderArtistGallery .slider__inner', {
            modules: [Pagination, Autoplay, Grid, FreeMode],
            spaceBetween: 16,
            speed: 900,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            grid: {
                rows: document.querySelectorAll('.jsSliderArtistGallery .slider__slide').length < 4 ? 1 : 2,
            },
            autoplay: {
                delay: 8000,
                disableOnInteraction: false, 
                waitForTransition: false,
            },
        
            pagination: {
                el: ".jsSliderArtistGallery .swiper-pagination",
                clickable: true,
                bulletClass: "slider__pagination-item",
            },
        });
        
        checkAutoplay(jsSliderArtistGallery, document.querySelector('.jsSliderArtistGallery'))
    }


    if(document.querySelector('.jsSliderImportantly')){
        const jsSliderImportantly = new Swiper('.jsSliderImportantly .slider__inner', {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 900,
            autoHeight: true,
            autoplay: {
                delay: 8000,
                disableOnInteraction: false, 
                waitForTransition: false,
            },
        
            pagination: {
                el: ".jsSliderImportantly .swiper-pagination",
                clickable: true,
                bulletClass: "slider__pagination-item",
            },
            navigation: {
                nextEl: '.jsSliderImportantly .swiper-button-next',
                prevEl: '.jsSliderImportantly .swiper-button-prev',
            },
        
            breakpoints: {
                0:{
                    spaceBetween: 12,
                },
        
                834: {
                    spaceBetween: 16,
                },
        
                992: {
                    pagination: false,
                    spaceBetween: 20,
                },
        
                1260: {
                    pagination: false,
        
                },
            }
        });
    
        checkAutoplay(jsSliderImportantly, document.querySelector('.jsSliderImportantly'))
    }


    if(document.querySelector('.jsSliderBadges')){
        let items = document.querySelectorAll('.jsSliderBadges');
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            
            const jsSliderBadges = new Swiper( item.querySelector('.slider__inner'), {
                modules: [Navigation, Pagination],
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 0,
                speed: 500,
                freeMode: true,
                mousewheel: true,
            });
        }
    } 


    if(document.querySelector('.jsSliderArticle')){
        let items = document.querySelectorAll('.jsSliderArticle');
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            
            const jsSliderArticle = new Swiper( item.querySelector('.slider__inner'), {
                modules: [Navigation, Pagination, Autoplay],
                loop: false,
                slidesPerView: 1,
                spaceBetween: 16,
                speed: 500,
                autoHeight: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false, 
                    waitForTransition: false,
                },

                navigation: {
                    nextEl: item.querySelector('.swiper-button-next'),
                    prevEl: item.querySelector('.swiper-button-prev'),
                },
            
                pagination: {
                    el: item.querySelector(".swiper-pagination"),
                    clickable: true,
                    bulletClass: "slider__pagination-item",
                },
            });

            checkAutoplay(jsSliderArticle, item)
        }
    } 


    if(document.querySelector('.jsSliderModalSteps')){
        let items = document.querySelectorAll('.jsSliderModalSteps');

        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            let steps = item.querySelectorAll('.jsModalStep');

            const jsSliderModalSteps = new Swiper( item.querySelector('.slider__inner'), {
                modules: [Pagination, Autoplay],
                loop: false,
                slidesPerView: 1,
                spaceBetween: 16,
                speed: 500,
                autoHeight: true,
                simulateTouch: false,

                pagination: {
                    el: item.querySelector(".swiper-pagination"),
                    clickable: true,
                    bulletClass: 'slider__step',
                    renderBullet: function(index){
                        return `<span class="slider__step">
                                    <span class="slider__step-inner">
                                        <span>${index + 1}</span>
                                        <svg class="icon">
                                            <use xlink:href="#ok-slim"></use>
                                        </svg>
                                    </span>
                                </span>`
                    },
                    bulletActiveClass: 'slider__step--active',
                },
                on: {
                    slideChange: () => {
                        let activeIndex = jsSliderModalSteps.activeIndex;
                        let stepsLinks = item.querySelectorAll('.slider__step');

                        stepsLinks.forEach((link, index) => {
                            if(activeIndex > index) {
                                link.classList.add('is-available')
                            } else{
                                link.classList.remove('is-available')
                            }
                        })
                    }
                }
            });     

            function resize() {
                jsSliderModalSteps.updateAutoHeight()
            };
            
            steps.forEach(step => {
                let button = step.querySelector('.jsModalStepSubmit');
                let inputs = step.querySelectorAll('.jsInput.jsInputReq');
                new ResizeObserver(resize).observe(step)

                if (button) {
                    button.addEventListener('click', () => {
                        let errors = 0;

                        inputs.forEach(input => {
                            if (input.value != '') {
                                window.inputStatusRemove(input, 'error')
                            } else{
                                window.inputStatusAdd(input, 'error')
                                errors++
                            }
                        })

                        if(errors == 0) {
                            jsSliderModalSteps.slideNext()
                        }
                    })
                }
            })
        }
    } 
})
